export default function delay(retryCount: number): Promise<void> {
  // Force a limit of 6 requests.
  if (retryCount > 6) {
    retryCount = 6;
  }

  return new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
}
